import { render, staticRenderFns } from "./OilPalmMap.vue?vue&type=template&id=2353ab8d&scoped=true&"
import script from "./OilPalmMap.vue?vue&type=script&lang=js&"
export * from "./OilPalmMap.vue?vue&type=script&lang=js&"
import style0 from "./OilPalmMap.vue?vue&type=style&index=0&id=2353ab8d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2353ab8d",
  null
  
)

export default component.exports